import React, { createContext, useContext, useState } from 'react'

const UserNamesContext = createContext()

const useUserNames = () => {
  return useContext(UserNamesContext)
}

const UserNamesProvider = ({ children }) => {
  const [userNames, setUserNames] = useState({})

  const setNickname = (userToken, nickname) => {
    setUserNames(userNames => ({
      ...userNames,
      [userToken]: nickname,
    }))
  }

  const getNickname = (userToken) => {
    return userNames[userToken] || userToken
  }

  return (
    <UserNamesContext.Provider value={{ setNickname, getNickname }}>
      {children}
    </UserNamesContext.Provider>
  )
}

export { useUserNames, UserNamesProvider }
